// @vendors
const trim = require('lodash/string/trim');

// @actions
const errorActions = require('actions/brokerError');
const brokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');

// @constants
const actionTypes = require('constants/actionTypes');
// @constants
const { API_CHANNEL } = require('constants/index');


// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const { getUsPersonFeatureFlag } = require('mifid/utilities/mifidFlagUsPersonHelpper');

const fetchSuccess = (response) => ({
    type: actionTypes.BROKER_MIFID_US_PERSON_FETCHING_SUCCESS,
    payload: { response }
});

const fetchingInfo = (isinId, marketId, optionalParams) => ({
    type: actionTypes.BROKER_MIFID_US_PERSON_FETCHING,
    payload: { isinId, marketId, optionalParams }
});

const fetchInfo = (isinId, marketId, optionalParams, history) => (dispatch, getState) => {
    const immBrokerMiFIDUSPerson = getState().brokerMiFIDUSPerson;
    const immFlagBasedFeatures =  getState().flagBasedFeatures;
    const usPersonFeatureFlag = getUsPersonFeatureFlag(
        !!optionalParams ? optionalParams.operationType : null
    );
    const disableUsPersonModal =
        !!usPersonFeatureFlag && immFlagBasedFeatures.get(usPersonFeatureFlag);
    const notFetching = !immBrokerMiFIDUSPerson.get('isFetching');
    const notFetched = !immBrokerMiFIDUSPerson.get('isFetched');

    let fetchInfoPromise;

    isinId = trim(isinId);
    marketId = marketId == null ? undefined : trim(marketId);

    if (notFetching && notFetched && isinId) {
        const url = apiURLBuilder.getURL('brokerMiFIDUSPerson');

        const requestData = {
            language: getLanguage().toLowerCase(),
            canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
            isinId,
            marketId
        };

        dispatch(fetchingInfo(isinId, marketId, optionalParams));

        fetchInfoPromise = APIGet(dispatch, url, { query: requestData }).then(
            (response) => dispatch(fetchSuccess({...response, disableUsPersonModal})),
            () => dispatch(errorActions.show('', true, history))
        );
    }
    return fetchInfoPromise;
};

const reset = () => ({
    type: actionTypes.BROKER_MIFID_US_PERSON_RESET,
    payload: {}
});

const sendUsPersonDataToMifid = (operationCode, isinId, marketId, disclaimers) => ({
    type: actionTypes.BROKER_CONVENIENCE_MIFID_TEST_SET_OPERATION_CODE_US_PERSON,
    payload: {
        operationCode,
        isinId,
        marketId,
        disclaimers
    }
});

const beforeContinueOperation = (history, continueCallback) => (dispatch, getState) => {
    const immBrokerMiFIDUSPerson = getState().brokerMiFIDUSPerson;
    const operationCode = immBrokerMiFIDUSPerson.get('operationCode');
    const isinId = immBrokerMiFIDUSPerson.get('isinId');
    const marketId = immBrokerMiFIDUSPerson.get('marketId');
    const disclaimers = immBrokerMiFIDUSPerson.get('disclaimers').toJS();
    const optionalParams = immBrokerMiFIDUSPerson.get('optionalParams').toJS();

    const fetchGetTest = brokerConvenienceMiFIDTestActions.fetchGetTest(
        operationCode,
        isinId,
        marketId,
        optionalParams,
        history
    );

    dispatch(sendUsPersonDataToMifid(operationCode, isinId, marketId, disclaimers));
    dispatch(fetchGetTest).then(
        () => continueCallback(history),
        () => dispatch(errorActions.show('', true, history))
    );
};

module.exports = {
    fetchInfo,
    reset,
    beforeContinueOperation
};
